/*
 * Constants.
 */

import {ContactsManagerParametersTypesEnum} from '../../../store/panels/contacts/contactsManager/parameters/contactsManagerParameters';

export enum AccountDetailsEventTypesEnum {
  COPY_LINK = 'copy_link',
  DELETE = 'delete',
  EDIT = 'edit',
  HOVER = 'hover',
  OPEN_CONVERSATION = 'open_conversation',
  VIEW = 'view',
}

export enum AccountDetailsHoverOptionsEnum {
  CONVERSATION = 'conversation',
}

export enum AccountDetailsEditActionsEnum {
  ADD = 'add',
  DELETE = 'delete',
  EDIT = 'edit',
}

export enum AccountDetailsEditAttributesEnum {
  AVATAR = 'avatar',
  CONTACTS = 'contacts',
  CUSTOM_FIELD = 'custom_field',
  DESCRIPTION = 'description',
  DOMAINS = 'domains',
  NAME = 'name',
}

export enum AccountDetailsOpenConversationSectionsEnum {
  LAST_7D = 'last_7d',
  OLDER = 'older',
  NONE = 'none',
}

/*
 * Event Types.
 */

interface AccountDetailsEvent {
  type: AccountDetailsEventTypesEnum;
}

export interface AccountDetailsViewEvent extends AccountDetailsEvent {
  type: AccountDetailsEventTypesEnum.VIEW;
  accountId: number;
  accountLocation?: ContactsManagerParametersTypesEnum;
}

export interface AccountDetailsHoverEvent extends AccountDetailsEvent {
  type: AccountDetailsEventTypesEnum.HOVER;
  section: AccountDetailsHoverOptionsEnum;
}

export interface AccountDetailsOpenConversationEvent extends AccountDetailsEvent {
  type: AccountDetailsEventTypesEnum.OPEN_CONVERSATION;
  section: AccountDetailsOpenConversationSectionsEnum;
}

export interface AccountDetailsEditEvent extends AccountDetailsEvent {
  type: AccountDetailsEventTypesEnum.EDIT;
  accountId: number;
  action: AccountDetailsEditActionsEnum;
  attribute: AccountDetailsEditAttributesEnum;
}

export interface AccountDetailsCopyLinkEvent extends AccountDetailsEvent {
  type: AccountDetailsEventTypesEnum.COPY_LINK;
  accountId: number;
}

export interface AccountDetailsDeleteEvent extends AccountDetailsEvent {
  type: AccountDetailsEventTypesEnum.DELETE;
  accountId: number;
}

/*
 * Union of Events and Handler.
 */

export type AccountDetailsTrackingEvent =
  | AccountDetailsViewEvent
  | AccountDetailsHoverEvent
  | AccountDetailsOpenConversationEvent
  | AccountDetailsEditEvent
  | AccountDetailsCopyLinkEvent
  | AccountDetailsDeleteEvent;
export type AccountDetailsTrackEventHandler = (event: AccountDetailsTrackingEvent) => void;

/*
 * Event Creators.
 */

export function buildAccountDetailsViewEvent(
  accountId: number,
  accountLocation?: ContactsManagerParametersTypesEnum,
): AccountDetailsViewEvent {
  return {
    type: AccountDetailsEventTypesEnum.VIEW,
    accountId,
    accountLocation,
  };
}

export function buildAccountDetailsHoverEvent(
  section: AccountDetailsHoverOptionsEnum,
): AccountDetailsHoverEvent {
  return {
    type: AccountDetailsEventTypesEnum.HOVER,
    section,
  };
}

export function buildAccountDetailsOpenConversationEvent(
  section: AccountDetailsOpenConversationSectionsEnum,
): AccountDetailsOpenConversationEvent {
  return {
    type: AccountDetailsEventTypesEnum.OPEN_CONVERSATION,
    section,
  };
}

export function buildAccountDetailsEditPayload(
  accountId: number,
  action: AccountDetailsEditActionsEnum,
  attribute: AccountDetailsEditAttributesEnum,
): AccountDetailsEditEvent {
  return {
    type: AccountDetailsEventTypesEnum.EDIT,
    accountId,
    action,
    attribute,
  };
}

export function buildAccountDetailsCopyLinkPayload(accountId: number): AccountDetailsCopyLinkEvent {
  return {
    type: AccountDetailsEventTypesEnum.COPY_LINK,
    accountId,
  };
}

export function buildAccountDetailsDeletePayload(accountId: number): AccountDetailsDeleteEvent {
  return {
    type: AccountDetailsEventTypesEnum.DELETE,
    accountId,
  };
}
